import styled from 'styled-components';

const IntroText = styled.div`
  position: relative;
  font-size: 54px;
  font-weight: 300;
  color: #ffffff;
  margin: 20px auto 40px;
  line-height: 1.3;
  padding-top: 130px;

  @media screen and (max-width: 768px) {
    font-size: 36px;
    padding-top: 80px;
    text-align: center;
  }

  @media screen and (max-width: 414px) {
    font-size: 36px;
    padding-top: 60px;
    text-align: center;
  }
`;

export default IntroText;



// WEBPACK FOOTER //
// ./src/components/landing/HeroBanner/IntroText.js